import { TKIconArrowDown, TKIconNotification } from "assets/images/svgs";
import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

const DashboardHeader = ({ section, infoText }) => {
  const { ngoProfile } = useSelector((state) => state.auth);

  return (
    <HeaderContainer>
      <div className="ml-[1rem] md:ml-[37px]">
        <TabName>
          {section ? section : `Hello, ${ngoProfile?.ngoProfile?.name}`}
        </TabName>
        <Info>{infoText}</Info>
      </div>
      <ProfileWrapper>
        <TKIconNotification />
        <div className="flex justify-center items-center gap-x-2">
          <div className="w-[45px] bg-[#213874] h-[45px] rounded-full flex justify-center items-center">
            <p className="text-[24px] font-medium text-white">
              {ngoProfile?.ngoProfile?.name.split(" ")[0].charAt(0)}
              {ngoProfile?.ngoProfile?.name.split(" ")[1].charAt(0)}
            </p>
          </div>
          <TKIconArrowDown className="" />
        </div>
      </ProfileWrapper>
    </HeaderContainer>
  );
};

export default DashboardHeader;

const HeaderContainer = styled.div.attrs({
  className: "border-b border-[#DFDFDF]",
})`
  height: 70px;
  width: 100%;
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.1);
`;

const TabName = styled.p.attrs({
  className: "text-[#222222] text-[16px] font-semibold",
})`
  white-space: nowrap;
`;

const ProfileWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-right: 33px;
  cursor: pointer;
`;

const Info = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #222222;
`;
